// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lwplj{display:flex;flex-direction:column;align-items:center;flex:1;gap:32px}.BLAza{display:flex;align-items:center;justify-content:center;flex:1}.qsmur{max-width:280px;width:100%}.q1dAi{color:var(--color-text-secondary)}.NpKpE{color:var(--color-success)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `lwplj`,
	"lottieContainer": `BLAza`,
	"lottie": `qsmur`,
	"waiting": `q1dAi`,
	"connected": `NpKpE`
};
export default ___CSS_LOADER_EXPORT___;
